export const MAX_DECIMALS = 5
export const MIN_DECIMALS = 2
export const PRECISION = 15
